import { Grid } from "@material-ui/core";
import { FormTextField } from "../../../components";
import React from "react";
import { AUDIT_LOGS_SERVER_DATE_FORMAT } from "../../../constants";
import { format } from "date-fns";
import moment from "moment";
import PropTypes from "prop-types";

export const Filter = (props) => (
  <Grid item md={2} sm={2} xs={12}>
      <FormTextField
        {...props}
        id={`${props.id}`}
        data-apim-test={`${props.id}`}
      />
    </Grid>
);

function convertDateToMilliSeconds(date) {
  const convertDate = moment(date, AUDIT_LOGS_SERVER_DATE_FORMAT).valueOf();
  return (
     format(date, convertDate.toString())
  )
}

function timeFormat(time) {
  return moment(time).format('YYYY-MM-DD  hh:mm');
}

Filter.propTypes = {
  id: PropTypes.string,
}


export {
  convertDateToMilliSeconds,
  timeFormat,
}